<!--
 * @FileDescription: 
 * @version: 2.0
 * @Author: 胡明浩
 * @Date: 2021-08-10 10:32:29
 * @LastEditors: 胡明浩
 * @LastEditTime: 2021-09-09 17:02:11
-->
<template>
	<div class="collectionAccount">
		<div class="container">
			<div class="crumbs">
				<el-button @click="addCollectionAccount" class="el-button-shen">新增收款账号</el-button>
			</div>
			<el-table ref="multipleTable" :data="tableData" border style="width: 100%" v-loading="isLoading">
				<el-table-column align="center" type="index" label="序号" min-width="50"></el-table-column>
				<el-table-column align="center" prop="bank" label="开户银行" min-width="200" show-overflow-tooltip></el-table-column>
				<el-table-column align="center" prop="bankAccounts" label="账号" min-width="200"></el-table-column>
				<el-table-column align="center" label="创建人身份" min-width="100">
					<template slot-scope="scope">{{ scope.row.accountType == 1 ?'个人账户':'企业账户'}}</template>
				</el-table-column>
				<el-table-column align="center" label="默认" min-width="100">
					<template slot-scope="scope">
						<span class="default" v-if="scope.row.isDefault">默认账号</span>
						<span class="setDefault" v-else @click="setDefault(scope.row.bankAccountId)">设为默认</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="address" label="操作" min-width="100" show-overflow-tooltip>
					<template slot-scope="scope">
						<div class="handle-btn">
							<p class="cz xg" @click="modifyInvoiceManage(scope.row.bankAccountId)">编辑</p>
							<p class="cz sc" @click="deleteInvoiceManage(scope.row.bankAccountId,scope.row.isDefault)">删除</p>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<add-collection-account
				:title="title"
				:dialogFormVisible="isDialogVisible"
				@close="close"
				:details="modifyData"
			></add-collection-account>
		</div>
	</div>
</template>

<script>
import AddCollectionAccount from '@/modules/projectA/components/nesting/addCollectionAccount'
import Api from '@/modules/projectA/api/nesting/inside'
export default {
	components: {
		AddCollectionAccount
	},
	data() {
		return {
			title: '添加收款账号',
			isLoading: false,
			isDialogVisible: false, //弹框
			modifyData: {},
			tableData: []
		}
	},
	mounted() {
		this.payeeAccount()
	},
	methods: {
		//收款账户列表
		payeeAccount() {
			this.isLoading = true
			Api.payeeAccount().then(res => {
				if (res.success) {
					this.tableData = res.data
					this.isLoading = false
				}
			})
		},
		//设为默认
		setDefault(bankAccountId) {
			Api.setDefaultAccount({
				bankAccountId: bankAccountId
			}).then(res => {
				if (res.success && res.data) {
					this.$message({
						type: 'success',
						message: '设置成功!'
					})
					this.payeeAccount()
				}
			})
		},
		modifyInvoiceManage(bankAccountId) {
			Api.selBankAccountById({
				bankAccountId: bankAccountId
			}).then(res => {
				this.modifyData = {
					...res.data
				}
				this.isDialogVisible = true
				this.title = '修改收款账号'
			})
		},
		deleteInvoiceManage(bankAccountId, isDefault) {
			if (isDefault) {
				this.$message.warning('默认账号不能删除')
				return
			}
			this.$confirm('您确定要删除此收款账号吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					Api.deleAccount({ bankAccountId: bankAccountId }).then(
						res => {
							if (res.success && res.data) {
								this.$message({
									type: 'success',
									message: '删除成功!'
								})
								this.payeeAccount()
							}
						}
					)
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					})
				})
		},
		addCollectionAccount() {
			this.title = '添加收款账号'
			this.modifyData = {}
			this.isDialogVisible = true
		},
		//关闭弹框
		close() {
			this.isDialogVisible = false
		}
	}
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog {
	margin-top: 0 !important;
	top: 50%;
	transform: translateY(-50%);
}
.handle-btn {
	display: flex;
	align-items: center;
	justify-content: center;
	.cz {
		cursor: pointer;
		&:hover {
			// text-decoration: underline;
		}
	}
	.xg {
		margin-right: 10px;
		color: #0064c8;
	}
	.sc {
		color: #f0250f;
	}
}
.default {
	color: #2587ff;
}
.setDefault {
	cursor: pointer;
	&:hover {
		// text-decoration: underline;
	}
}
</style>